import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubscriptionPlans from '../SubscriptionPlans/SubscriptionPlans';
import UserProfile from '../UserProfile/UserProfile';
import './Header.css';
import { PROFILE_USER_AVATAR } from '../../constant';

const Header = ({ creditsAvailable }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="header fixed top-0 left-0 right-0 h-16 z-50 bg-gradient-to-r from-white to-gray-50 shadow-md backdrop-blur-xl">
        <div className="px-4 h-full flex items-center justify-between w-full">
          <div
            className="logo text-2xl md:text-3xl font-extrabold bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent cursor-pointer"
            onClick={() => navigate('/webapp')}
          > Shutter
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* Desktop and Mobile Menu */}
          <div className={`header-right ${isMenuOpen ? 'mobile-menu-open' : 'mobile-menu-closed'}`}>
            <div className="credits bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-full px-4 py-2 shadow-sm hover:shadow-md transition-all duration-300 relative group">
              <span className="credit-icon text-yellow-500 text-xl animate-pulse">⭐</span>
              <span className="credit-text text-yellow-800 font-semibold">{creditsAvailable}</span>
              
              {/* Floating Tooltip */}
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-4 py-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50" style={{ minWidth: '350px' }}>
                <div
                  className="flex items-start gap-3 px-5 py-4 text-sm font-medium rounded-lg border shadow-md bg-white"
                  style={{
                    borderColor: '#a78bfa', // soft purple
                    color: '#23272f',
                    boxShadow: '0 2px 12px 0 rgba(124,58,237,0.08)',
                    fontSize: '0.95rem',
                    whiteSpace: 'normal', // Allow text to wrap
                    lineHeight: '1.5', // Improve readability of wrapped text
                  }}
                >
                  {/* <span style={{ fontSize: '1.2em', color: '#a78bfa', marginTop: '0.1em', flexShrink: 0 }}>💜</span> */}
                  <div className="flex-1">
                    <div className="font-bold mb-2 text-purple-700 text-base">
                      <span style={{ fontSize: '1.3em', verticalAlign: 'middle' }}>💜</span> Credit Deduction Plan
                    </div>
                    <div className="space-y-1">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-700">New Product:</span>
                        <span className="font-semibold text-purple-600">10 credits</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-700">New Style:</span>
                        <span className="font-semibold text-purple-600">10 credits</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-700">Each Image Gen:</span>
                        <span className="font-semibold text-purple-600">1 credit</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-700">Upscale download:</span>
                        <span className="font-semibold text-purple-600">1 credit</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              className="get-pro-btn bg-gradient-to-r from-purple-600 via-indigo-600 to-purple-600 text-white px-6 py-2.5 rounded-xl font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300 shadow-md"
              onClick={() => setShowSubscriptionModal(true)}
            >
              Upgrade
            </button>
            <div className="relative group cursor-pointer" onClick={() => setShowProfileModal(true)}>
              <img
                src={PROFILE_USER_AVATAR}
                alt="User Avatar"
                className="avatar rounded-full border-2 border-purple-200 group-hover:border-purple-400 transition-all duration-300 shadow-md hover:shadow-lg"
              />
              <div className="absolute bottom-0 right-0 h-3.5 w-3.5 bg-green-400 rounded-full border-2 border-white shadow-sm animate-pulse"></div>
            </div>
          </div>
        </div>
      </header>

      {/* Subscription Plans Modal */}
      {showSubscriptionModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl" onClick={() => setShowSubscriptionModal(false)}></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={() => setShowSubscriptionModal(false)}
                  >
                    <span className="sr-only">Close</span>
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <SubscriptionPlans readOnly={false} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Profile Modal */}
      {showProfileModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl" onClick={() => setShowProfileModal(false)}></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full max-h-[45vh] overflow-y-auto">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={() => setShowProfileModal(false)}
                  >
                    <span className="sr-only">Close</span>
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <div className="max-h-[35vh] overflow-y-auto">
                  <UserProfile />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;

// import React from "react";

// const Header = () => {
//   return (
//     <header className="flex items-center justify-between p-4 border-b border-gray-200 bg-white shadow">
//       <div className="flex items-center">
//         <img
//           src="https://storage.googleapis.com/a1aa/image/0Si0SmLWz_ab_G8bsRQbm0_zBBduFfPAMd2EgId_HWA.jpg"
//           alt="Shutter Labs Logo"
//           className="h-8"
//         />
//       </div>
//       <div className="flex items-center space-x-4">
//         <span className="text-yellow-500">150 Credits Left</span>
//         <button className="bg-purple-600 text-white px-4 py-2 rounded">Get Pro</button>
//         <img
//           src="https://storage.googleapis.com/a1aa/image/YtlHMATDbhGvuTItudFZZcpENlFINGDbDp53eBVkyA4.jpg"
//           alt="User Avatar"
//           className="h-10 w-10 rounded-full"
//         />
//       </div>
//     </header>
//   );
// };

// export default Header;
